import { AppService } from 'app/app.service';

/**
 * api-quote's ERROR_DEAL_PROJECT_CASCADE (api-project's is the same number) — the deal and its
 * other quotes would move with the project, and the caller has to say it means that.
 */
export const QUOTE_ERROR_DEAL_PROJECT_CASCADE = 20;

/** api-quote's ERROR_DEAL_PROJECT_LOCKED — the deal's project is settled by an invoiced quote. */
export const QUOTE_ERROR_DEAL_PROJECT_LOCKED = 21;

/**
 * Sends a quote's project change through `send` (api.quote.setProject or
 * api.project.addQuotesToProject). When the server asks, the user confirms the whole deal moving
 * and it is resent with `confirm_deal_project`; Cancel calls `cancelled` and nothing is saved.
 */
export const sendDealProjectChange = (app: AppService, send: (data, done, fail) => void, data, done, fail, cancelled: () => void = null) => {
	send(data, done, error => {
		if (error?.code !== QUOTE_ERROR_DEAL_PROJECT_CASCADE) {
			fail?.(error);
			return;
		}

		// Fixed, so it can only be answered with a button and `cancelled` always runs.
		app.dialog.popFixed('Change the project for the whole deal?', error.message, ['Cancel', '*Change all'], btn => {
			if (btn === 1) {
				send({ ...data, confirm_deal_project: 1 }, done, fail);
			} else {
				cancelled?.();
			}
		});
	});
};
